import React from "react";
import Contact from "../components/contac/Contac";

const ContactPage = () => {
  return (
    <div className="container" style={{ marginTop: "10rem" }}>
      <Contact />
    </div>
  );
};

export default ContactPage;
